import React from 'react';
import Typography from "@material-ui/core/Typography";
import Paper from '@material-ui/core/Paper';
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";

//css
import MainCss from './Main-css';
const useStyles = MainCss();

const content = (props) => {
    const classes = useStyles();
    return (
        <div className={classes.root}>
            <Paper className={classes.paper}>
                {props.state.isLoading &&
                    <div align="center">
                        <CircularProgress />
                    </div>
                }
                {!props.state.isLoading &&
                    <div className={classes.buttonFile}>
                        <input
                            accept=".pdf"
                            className={classes.input}
                            id="btFile"
                            multiple
                            onChange={props.handlerArquivo}
                            type="file"
                        />                                          
                        <div className={classes.lb_arquivo}>
                            {props.state.nomeArquivo}
                        </div>
                        <label htmlFor="btFile">
                            <Button raised="true" component="span" variant="contained" color="primary" >
                                Upload do Arquivo
                            </Button>
                        </label>
                        <Typography id={"extensao"} className={classes.cardFileText} color="textSecondary" gutterBottom>
                            Extensões permitidas: .pdf.
                        </Typography>
                        <Typography id={"tamanho"} className={classes.cardFileText} color="textSecondary" gutterBottom>
                            Tamanho máximo de arquivo 5mb.
                        </Typography>
                    </div>
                }
            </Paper>
        </div>
    );
};

export default content;